import React from 'react'
import { Link } from 'react-router-dom'

import NKIcon from '@norkart/ikoner'
import {Maalerstatus} from '../../felles/utils/statuskoder'

import { datoFormatMedTidspunktTekst } from '../../felles/utils/dato-format-tabell'

export default ({ maaler, match }) => {
    
    let cssKlasse = 'list-group-item'
    let ikon = <NKIcon icon="hoyrepil" color="nk-black" size="1" />
    let avtalt= ""
    if (maaler.Status === Maalerstatus.Skiftet){
        cssKlasse += ' vaamaalerliste-element-skiftet'
        ikon = <NKIcon icon="velg" color="nk-black" size="1" />
    }
        
    if (maaler.Status === Maalerstatus.IkkeSkiftet){
        cssKlasse += ' vaamaalerliste-element-ikke-skiftet'
        ikon = <NKIcon icon="advarsel" color="nk-black" size="1" />
    }
        
    if (maaler.Status <= Maalerstatus.Avtalt){
        cssKlasse += ' vaamaalerliste-element'
        
    }

    if(maaler.Status === Maalerstatus.Avtalt){
        avtalt = "Avtalt"
    }
        

    return (
        <Link className={cssKlasse} to={`${match.url}/vannmaaler/` + maaler.MaalerId}>
            <div style={{ float: 'right', overflow: 'hidden' }}>    
                {
                    ikon
                }

            </div>
            <div style={{ float: 'left', overflow: 'hidden' }} >                               
                <strong className='font16'>{maaler.Maalepunktadresse} {maaler.Husnummer} {maaler.Husbokstav} </strong>                                        
                <br />
                <p>{maaler.Eiernavn} </p>
                <p style={{ display: 'inline' }}>{avtalt} {datoFormatMedTidspunktTekst(maaler.Avtaltdato)}</p>
                <p >{maaler.Kommentar} </p>

            </div>
            <div style={{ float: 'none', clear: 'both' }}></div>
        </Link>
    )
}



// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/vannmaaler-item.jsx